import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { theme } from "./theme";
import { AuthProvider } from "./auth/AuthContext";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { AppShell } from "./layout/AppShell";

import LoginPage from "./pages/LoginPage.jsx";
import DashboardPage from "./pages/DashboardPage.jsx";
import UsersPage from "./pages/admin/UsersPage.jsx";
import RolesPage from "./pages/admin/RolesPage.jsx";
import ModuleConfigsPage from "./pages/admin/ModuleConfigsPage.jsx";
import ApiKeysPage from "./pages/admin/ApiKeysPage.jsx";
import { MODULE_COMPONENTS } from "./modules/registry";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

export default function App() {
  return (
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <Notifications position="top-right" />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                element={
                  <ProtectedRoute>
                    <AppShell />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardPage />} />
                <Route
                  path="admin/users"
                  element={
                    <ProtectedRoute requireAdmin>
                      <UsersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="admin/roles"
                  element={
                    <ProtectedRoute requireAdmin>
                      <RolesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="admin/module-configs"
                  element={
                    <ProtectedRoute requireAdmin>
                      <ModuleConfigsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="admin/api-keys"
                  element={
                    <ProtectedRoute requireAdmin>
                      <ApiKeysPage />
                    </ProtectedRoute>
                  }
                />
                {Object.entries(MODULE_COMPONENTS).map(([key, Comp]) => (
                  <Route
                    key={key}
                    path={`modules/${key}`}
                    element={<Comp />}
                  />
                ))}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </MantineProvider>
  );
}
